import { useMemo } from 'react';
import { ImageElement } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/ImageElement';
import { TransitionLifeCycleType } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { VideoElement } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/VideoElement';
import { getElementTransitionByLifeCycleType } from '@goldcast/player-config/src/utils/playerConfigUtils';
import { TransitionLifeCycleTab } from './TransitionLifeCycleTab';

export const TransitionLifeCycle = ({
  selectedElement,
  transitionLifeCycle,
  onClickTransitionLifeCycleTab
}: {
  transitionLifeCycle: TransitionLifeCycleType;
  onClickTransitionLifeCycleTab: (lifeCycle: TransitionLifeCycleType) => void;
  selectedElement: ImageElement | VideoElement;
}) => {
  const inTransitionExists = useMemo(() => {
    return getElementTransitionByLifeCycleType(selectedElement, TransitionLifeCycleType.IN) !== null;
  }, [selectedElement]);

  const outTransitionExists = useMemo(() => {
    return getElementTransitionByLifeCycleType(selectedElement, TransitionLifeCycleType.OUT) !== null;
  }, [selectedElement]);
  return (
    <div className="flex h-10 w-full gap-1 rounded-lg bg-slate-100 p-1">
      <TransitionLifeCycleTab
        transitionLifeCycle={TransitionLifeCycleType.IN}
        isTransitionApplied={inTransitionExists}
        isActive={transitionLifeCycle === TransitionLifeCycleType.IN}
        label="In"
        onClick={onClickTransitionLifeCycleTab}
      />
      <TransitionLifeCycleTab
        transitionLifeCycle={TransitionLifeCycleType.OUT}
        isTransitionApplied={outTransitionExists}
        isActive={transitionLifeCycle === TransitionLifeCycleType.OUT}
        label="Out"
        onClick={onClickTransitionLifeCycleTab}
      />
    </div>
  );
};
